<template>
  <div class="d-flex align-center justify-space-between">
    <p
    @click="download"
    :style="canDownload ? 'cursor: pointer': ''"
    v-bind="{
      ...getTitleAttr
    }">
      {{name}} - <i>{{sizeLabel}}</i>
    </p>
    <div class="d-flex">
      <icon-button
      v-if="canPreview"
      @click="previewImage"
      src="eye"
      color="blue"/>
      <icon-button
      @click="$emit('remove')"
      :disabled="disabled"
      src="minus"
      color="red"/>
    </div>
  </div>
</template>

<script>
import IconButton from '@/components/btns/IconButton'
export default {
  components: {
    IconButton
  },
  props: {
    name: {
      type: String,
      required: true
    },
    sizeLabel: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    downloadLink: {
      type: String,
      default: null
    },
    previewLink: {
      type: String,
      default: null
    }
  },
  computed: {
    canDownload() {
      return this.downloadLink !== null
    },
    canPreview() {
      return new RegExp(/\.(png)|(jpeg)|(jpg)|(webp)|(ico)$/).test(this.name.toLowerCase())
    },
    getTitleAttr() {
      return this.canDownload ? {
        title: this.$t("common.downloadAttachment", { "0": this.name})
      } : {}
    }
  },
  methods: {
    download() {
      if (!this.canDownload) return

      const a = document.createElement("a")
      a.href=this.downloadLink
      a.target="_self"
      a.setAttribute('download', this.name);
      document.body.appendChild(a)
      a.click()
      a.remove()
    },
    previewImage() {
      this.$imagePreviewDialog.open(this.previewLink, this.name)
    }
  }
}
</script>

<style>

</style>